import { Box, Flex, Text } from '@chakra-ui/react';

export const FormCustomError = ({ formik = {}, errorMessage }) => {
  const { isValid, isSubmitting, submitCount, errors = {} } = formik || {};

  const { base } = errors;
  const errorMessageToDisplay =
    base || errorMessage || `Can't submit yet. Check for required fields.`;

  const isInvalid = !(isValid || isSubmitting || !submitCount);

  if (!isInvalid) return null;
  return (
    <Flex
      mb="3px"
      gap="5px"
      justifyContent="center"
      w="100%"
      alignItems="center"
      pos="sticky"
      top="0"
      zIndex="5"
    >
      <Box
        bgColor={isInvalid ? 'red.100' : 'transparent'}
        p="10px 20px"
        borderRadius="8px"
      >
        <Text size="xxl-regular" color="ats-negative">
          Error:{' '}
          <Text fontSize="sm" color="ats-negative" as="span">
            {errorMessageToDisplay}
          </Text>
        </Text>
      </Box>
    </Flex>
  );
};
